import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useSiteSettings } from '../hooks/useSiteSettings';

export const InventoryGate = ({ children }) => {
  const settings = useSiteSettings();
  if (!settings) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#1a5c3b]" /></div>;
  }
  if (!settings.inventory_enabled) return <Navigate to="/" replace />;
  return children;
};
